import { ZomentumRoutes } from '@/Contracts';

/**
 * SuperOps Integration Configuration
 * All SuperOps-related settings in one place
 */

export const SUPEROPS_CONFIG = {
  // Domain allowlist for iframe embedding (supports wildcards)
  ALLOWED_IFRAME_DOMAINS: [
    'http://localhost:4000',
    'http://localhost:3000',
    'https://localhost:3000',
    'http://127.0.0.1:3000',
    'https://127.0.0.1:3000',
    'https://*.channelforcestage.com',
    'https://*.channelforcecanary.com',
    'https://*.zomentum.com',
    'https://*.superopsalpha.com',
    'http://mylocaldev.superopsalpha.com:5553',
    'https://mylocaldev.superopsalpha.com:5553'
  ],

  // Routes that work in any iframe (no domain restrictions)
  UNIVERSAL_IFRAME_ROUTES: [
    '/login',
    '/authorize'
  ],

  // Allowed embed routes (with domain restrictions)
  ALLOWED_EMBED_ROUTES: [
    // Core business routes
    { path: ZomentumRoutes.OpportunityList, exact: true },
    { path: ZomentumRoutes.OpportunityDetail, exact: true },
    { path: ZomentumRoutes.BulkImportOpportunities, exact: true },
    { path: ZomentumRoutes.DocumentsList, exact: true },
    { path: ZomentumRoutes.DocumentsDetail, exact: true },
    { path: ZomentumRoutes.DocumentsPreview, exact: true },
    { path: ZomentumRoutes.DocumentsPdfView, exact: true },
    { path: ZomentumRoutes.TemplatesDetail, exact: true },
    
    // Authentication & setup
    { path: ZomentumRoutes.Login, exact: true },
    { path: ZomentumRoutes.Authorize, exact: true },
    { path: ZomentumRoutes.VerifyEmail, exact: true },
    { path: ZomentumRoutes.SetupAccount, exact: true },
    
    // Document workflows
    { path: ZomentumRoutes.SignatureSuccessIframe, exact: true },
    { path: ZomentumRoutes.DocumentSuccessSignature, exact: true },
    { path: ZomentumRoutes.VerifyPayment, exact: true },
    
    // Error handling
    { path: ZomentumRoutes.Error, exact: true },
    { path: ZomentumRoutes.Unauthorized, exact: true }
  ],

  // Communication message types
  MESSAGE_TYPES: {
    RESTORE_STATE: 'superops_restore_state' as const,
    FETCH_DATA: 'superops_fetch_data' as const,
    DATA_RESPONSE: 'superops_data_response' as const,
    OPEN_CLIENT_IN_NEW_TAB: 'superops_open_client_new_tab' as const
  },

  // State management settings
  STATE_STORAGE: {
    KEY: 'superops_pending_restore',
    EXPIRY_MINUTES: 30
  },

  // CSS class names
  CSS_CLASSES: {
    EMBEDDED_MODE: 'embedded-mode',
    HEADER_ROW_SUPEROPS: 'header-row-superops',
    HEADER_CHILDREN_SUPEROPS: 'header-children-superops'
  },

  // Error and redirect routes
  ROUTES: {
    ERROR: '/error',
    LOGIN_EMBED: '/login?embed=true'
  }
};